import _ from "lodash";
import { parse } from "date-fns";
import ImageDB from "entity/ImageDB";
import { compareOp } from "util/lang";
import { parseDuration } from "util/datetime"
// import { GraficoPadrao } from "entity/Indicador/components/GraficoPadraoPainel";
// import GraficoPadraoRelatorio from "./components/GraficoPadraoRelatorio";

/**
 * Classe abstrata para representação de dados de indicadores de laudos.
 */
export default class Indicador {
    constructor(type) {
        if (this.constructor === Indicador) {
            throw new Error("Indicador é uma classe abstrata e deve ser herdada");
        }

        /**
         * Tipo do indicador.
         */
        this.type = type;
    }

    //
    // Métodos abstratos.
    //

    /**
     * Nome do dado ser exibido.
     */
    static get fullName() {
        throw new Error("static get fullName() deve ser definido com o nome do indicador");
    }

    /**
     * Abreviação do nome do indicador, usado como ID em alguns registros.
     */
    static get abbrev() {
        throw new Error("static get abbrev() deve ser definido com a abreviação do nome do indicador");
    }

    /**
     * Campo em que o dado é armazenado no apontamento e nas configurações do indicador.
     * Por padrão utiliza a abreviação, em minúsculo.
     */
    static get field() {
        // if (this.multTipo) {
        //     console.log("this.type ", this.type);
        //     return this.type + "." + this.abbrev.toLowerCase();
        // }
        return this.abbrev.toLowerCase();
    }

    static get multTipo() {
        return false
    }

    // _typeName = ""
    // static get tipoNome() {
    //     return "oi"
    //     // return this._typeName
    // }

    // /**
    //  * @param {string} tipoN
    //  */
    // set tipoNome(tipoN) {
    //     this._typeName = tipoN

    //     //     _.set(this, "_typeName", tipoN)
    // }

    /**
     * Executa transformações de dados do indicador na visita.
     */
    async onLoad(visita) {
        this.migrateLegacyApontamentos(visita);

        for (const apontamento of this.getApontamentos(visita)) {
            await ImageDB.loadBase64Array(apontamento.images);
            await ImageDB.loadBase64Array(apontamento.coletas, "image.uid", "image.base64");
        }
    }

    /**
     * Executa transformações de dados antes de salvar.
     */
    async preSave(visita) {
        for (const apontamento of this.getApontamentos(visita)) {
            const ref = { type: this.constructor.abbrev, uid: visita.data.uid };
            apontamento.indicador = this.constructor.abbrev.toLowerCase();
            await ImageDB.fromBase64Array(apontamento.images, ref);
            await ImageDB.fromBase64Array(apontamento.coletas, ref, "image.uid", "image.base64");
        }
    }

    /**
     * Inicializa dados em um novo apontamento.
     */
    async initializeApontamento(apontamento) {
        apontamento.date = new Date();
        apontamento.tipo = "Manual";
    }

    /**
     * Mapa entre apontamentos antigos e novos no indicador.
     */
    static get legacyApontamentoMap() {
        return {};
    }

    /**
     * Mapa entre parâmetros antigos e novos no cliente.
     */
    static get legacyParamMap() {
        return {};
    }

    /**
     * Campos de formulário para configuração de parâmetros de referência de conformidade
     * usados no cálculo do indicador.
     */
    static paramFields() {
        throw new Error(
            "static paramFields() deve ser definido com os campos de formulário de parâmetros do indicador"
        );
    }

    /**
     * Campos de formulário para edição do apontamento.
     */
    static getEditFields(visita) {
        throw new Error(
            "static get static getEditFields(visita) deve ser definido com os campos de formulário de edição do indicador"
        );
    }

    // /**
    //  * Gera o gráfico no painel de relatórios
    //  */
    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <GraficoPadrao mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
    // }

    // /**
    //  * Gera os gráficos secundário no painel de relatórios
    //  */
    // static getGraficoExtraPainel(indicadorProps, nomeAgrupador) {
    //     return <></>
    // }

    // /**
    //  * Gera o gráfico no relatório
    //  */
    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return GraficoPadraoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    // /**
    //  * Gera os gráficos secundário no relatório
    //  */
    // static getGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente) {
    //     // console.log('Esse indicador não possui gráfico secundário')
    // }

    /**
     * Gera conteúdo do indicador para inserir no relatório em formato do pdfmake.
     */
    async renderReport(visita) {
        return null;
    }

    /**
     * Gera conteúdo do resumo do indicador para inserir no relatório em formato do pdfmake.
     */
    async renderReportSummary(visita, tipoName) {
        return null;
    }

    /**
     * Calcula conformidade do apontamento, baseado nos parâmetros do cliente.
     *
     * @param {*} apontamento Apontamento a ser atualizado.
     * @param {*} params Parâmetros do cliente.
     * @returns Conformidade (%).
     */
    static calcConformidade(apontamento, params) {
        throw new Error("static calcConformidade() deve ser definido com o cálculo de conformidade do apontamento");
    }

    /**
     * Retorna o status da conformidade ("Ótimo", "Bom", "Regular" ou "Ruim").
     */
    static getConformidadeStatus(conformidade, meta) {
        throw new Error("static getConformidadeStatus() deve ser definido com o status conformidade do indicador");
    }

    /**
     * Calcula a classificação de cada coleta do apontamento de acordo com os pontos amostrados configurados no cliente.
     *
     * @param {*} apontamento Apontamento com as coletas a serem classificadas.
     * @param {*} paramItems Parâmetros dos pontos amostrados do cliente.
     * @returns Lista de classificações e a quantidade de coletas em cada classificação.
     */
    static calcPontosAmostrados(apontamento, paramItems) {
        throw new Error(
            "static calcPontosAmostrados() deve ser definido com o cálculo de classificação de pontos amostrados do apontamento"
        );
    }

    //
    // Fim dos métodos abstratos.
    //

    get apontamentosField() {
        return `apontamentos.${this.type.field}.${this.constructor.field}`;
    }

    /**
     * Cria um novo apontamento na visita.
     * Retorna o índice do apontamento criado.
     */
    async createApontamento(visita, talhao) {
        const apontamento = {};
        await this.initializeApontamento(apontamento);
        apontamento.talhao = talhao ?? null
        const currentApontamentos = this.getApontamentos(visita);
        _.set(visita.data, this.apontamentosField, [...currentApontamentos, apontamento]);

        // Index do novo apontamento = final do array.
        return this.getApontamentos(visita).length - 1;
    }

    /**
     * Remove um apontamento da visita com o índice especificado.
     */
    removeApontamento(visita, index) {
        // TODO: remover imagens
        this.getApontamentos(visita).splice(index, 1);
        visita.save();
    }

    getApontamentos(visita) {
        return _.get(visita.data, this.apontamentosField) || [];
    }

    static calcConformidadeStatus(conformidade, meta, minRegular, minBom, minOtimo) {
        const percentual = conformidade / (parseFloat(meta) / 100);

        if (!_.isNaN(percentual)) {
            if (percentual >= minOtimo) {
                return "Ótimo";
            } else if (percentual >= minBom) {
                return "Bom";
            } else if (percentual >= minRegular) {
                return "Regular";
            } else {
                return "Ruim";
            }
        }
    }

    static calcConformidadeStatusDCor(conformidade, min, max) {
        if (!_.isNaN(conformidade)) {
            if (conformidade > (max + 15) || conformidade < (min - 15)) {
                return "Ruim";
            } else if (conformidade > max || conformidade < min) {
                return "Regular";
            } else {
                return "Ótimo";
            }
        }
    }

    static calcConformidadeStatusInverte(conformidade, meta, minRegular, minBom, minOtimo) {
        const percentual = conformidade / (parseFloat(meta) / 100);

        if (!_.isNaN(percentual)) {
            if (percentual <= minOtimo) {
                return "Ótimo";
            } else if (percentual <= minBom) {
                return "Bom";
            } else if (percentual <= minRegular) {
                return "Regular";
            } else {
                return "Ruim";
            }
        }
    }

    static calcPontoAmostradoColeta(paramItem, coletaValue) {
        const result1 = compareOp(coletaValue, paramItem.sinalIntervaloMin, paramItem.intervaloMin);
        const result2 = compareOp(coletaValue, paramItem.sinalIntervaloMax, paramItem.intervaloMax);

        if (paramItem.intervaloMin && !paramItem.intervaloMax) {
            return result1;
        } else if (paramItem.intervaloMax && !paramItem.intervaloMin) {
            return result2;
        } else {
            return result1 && result2;
        }
    }

    /**
     * Retorna a média de um campo nos apontamentos da visita, ou undefined se não houverem apontamentos do tipo.
     *
     * @param {*} visita
     * @param {*} field
     * @param {*} tipoName (Opcional) "Manual" ou "Mecanizado".
     */
    getAverage(visita, field, tipoName) {
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName);

        if (apontamentos.length && field === "tempoRegistrado") {
            // console.log("apontamentos", apontamentos)
            // console.log("field", field)
            let apts = apontamentos.map(a => {
                let apt = _.get(a, field)
                if (!apt) {
                    apt = _.get(a, 'tempoRegistrado')
                }
                return parseInt(parseDuration(apt))
            })
            let sum = apts.reduce((a, b) => a + b, 0)
            let avg = sum / apts.length
            console.log("apts", apts)
            console.log("nº apts", apts.length)
            console.log("sum", sum)
            console.log("avg", avg)

            return avg
        }

        if (!_.isEmpty(apontamentos)) {
            return _.meanBy(apontamentos, (a) => parseFloat(_.get(a, field, 0)));
        }
    }

    /**
     * Migra apontamentos na visita do formato antigo para o novo.
     */
    migrateLegacyApontamentos(visita) {

        // if (_.has(visita.data, this.apontamentosField)) {
        //     // Migração já realizada.
        //     return;
        // }

        const apontamentos = [];

        this.forEachLegacyApontamento(visita, (apontamento) => {
            const legacyMap = this.constructor.legacyApontamentoMap;
            const newApontamento = {};

            for (const field in legacyMap) {
                let newField;
                let value;
                const oldValue = _.get(apontamento, field);

                if (legacyMap[field].convert) {
                    newField = legacyMap[field].newField;
                    value = legacyMap[field].convert(oldValue, _.get(newApontamento, newField))//valor antigo e o valor atual no novo para update
                } else if (legacyMap[field].type === Array) {
                    const children = legacyMap[field].children;
                    newField = legacyMap[field].newField;

                    if (oldValue) {
                        value = oldValue.map((v) => {
                            // Converte cada elemento do array de acordo com o mapa de parâmetros.
                            const result = {};

                            for (const key in children) {
                                let childNewField;
                                let childValue = _.get(v, key);

                                if (children[key].convert) {
                                    childNewField = children[key].newField;
                                    childValue = children[key].convert(childValue);
                                } else {
                                    childNewField = children[key];
                                }

                                if (childValue) {
                                    _.set(result, childNewField, childValue);
                                }
                            }

                            return result;
                        });
                    }
                } else {
                    newField = legacyMap[field];
                    value = oldValue;
                }

                if (newField && value) {
                    _.set(newApontamento, newField, value);
                }
            }

            if (!_.isEmpty(newApontamento)) {
                apontamentos.push(newApontamento);
            }
        });

        if (!_.isEmpty(apontamentos)) {
            _.set(visita.data, this.apontamentosField, apontamentos);

            // TODO: remover antigo?
            // _.unset(visita.data, this.type.field);
        }
    }

    /**
     * Itera sobre os apontamentos da visita no formato antigo.
     */
    forEachLegacyApontamento(visita, callback) {
        const data = _.get(visita.data, this.type.field);

        if (data) {
            for (const apontamento of data) {
                if (apontamento.nomeAmostra === this.constructor.abbrev) {
                    callback(apontamento);
                }
            }
        }
    }

    static parseLegacyDate(date) {
        // console.log('date', date)
        return parse(date, "dd'T'HH:mm/MM/yyyy", new Date());
    }

    static convertLegacyImageUid(value) {
        return _.isString(value) ? value : null;
    }

    static getTableRelApontamentos(paramsCliente) {
        return null
    }

    static getColorStatus(status) {
        const conformidadeColors2 = {
            Ótimo: "#6bd72d",
            Bom: "#6bd72d",
            Regular: "#ecdb23",
            Ruim: "#fe4719",
            '': '#0080ff', // relatórios 
        }

        return conformidadeColors2[status]
    }
}
